export default function Terminos() {
  return (
    <div className="legal-page font-sans max-w-3xl mx-auto px-6 py-16 text-slate-700">
      <a href="/" className="text-sm text-brand-blue font-medium">&larr; Volver a Conciliabanco</a>
      <h1 className="text-3xl font-extrabold text-navy-900 mt-4 mb-1">Términos y condiciones</h1>
      <p className="text-sm text-slate-400 mb-8">Última actualización: 2026.</p>

      <div className="space-y-7 text-sm leading-relaxed">
        <p className="rounded-lg bg-amber-50 border border-amber-200 text-amber-800 px-4 py-3 text-xs">
          Este documento es un borrador funcional, no un texto certificado por un abogado.
          Antes de operar comercialmente, hazlo revisar por un abogado en Colombia.
        </p>

        <section>
          <h2 className="font-bold text-navy-900 mb-2">1. Quiénes somos</h2>
          <p>
            Conciliabanco es un servicio web de conciliación bancaria operado por{' '}
            <strong>Andrés Usuga</strong> ("Conciliabanco", "nosotros"), dirigido a empresas y
            contadores en Colombia. Puedes contactarnos en{' '}
            <a href="mailto:concilia@conciliabanco.com" className="text-brand-blue">concilia@conciliabanco.com</a>.
          </p>
        </section>

        <section>
          <h2 className="font-bold text-navy-900 mb-2">2. El servicio</h2>
          <p>
            Conciliabanco permite cargar un extracto bancario y un auxiliar contable para generar
            de forma automática la conciliación entre ambos, junto con reportes descargables
            (Excel/PDF) e historial de conciliaciones anteriores. El servicio se presta
            "tal cual" (as is): no garantizamos que el resultado esté libre de errores derivados
            de la calidad o el formato de los archivos que el usuario carga, y es responsabilidad
            del usuario revisar el resultado antes de usarlo con fines contables o fiscales
            formales.
          </p>
        </section>

        <section>
          <h2 className="font-bold text-navy-900 mb-2">3. Cuenta y registro</h2>
          <p>
            Para usar Conciliabanco debes registrar tu empresa con datos veraces y mantener la
            confidencialidad de tu contraseña. Eres responsable de la actividad que ocurra bajo
            tu cuenta y de los usuarios adicionales que tu empresa autorice dentro de la
            plataforma.
          </p>
        </section>

        <section>
          <h2 className="font-bold text-navy-900 mb-2">4. Planes, pagos y facturación</h2>
          <p>
            Conciliabanco se ofrece bajo un plan "Profesional" con modalidad mensual
            ($30.000 COP/mes) o anual ($240.000 COP/año). El acceso al servicio requiere una
            suscripción activa; no se ofrece periodo de prueba gratuito salvo que se indique
            expresamente al momento del registro. Los pagos se procesan a través de la pasarela
            Wompi; Conciliabanco no almacena los datos completos de tu tarjeta.
          </p>
          <p className="mt-2">
            La suscripción se renueva manualmente por el usuario al vencer cada periodo (mensual
            o anual); Conciliabanco no realiza cobros automáticos recurrentes sin una nueva
            confirmación de pago. Si tu suscripción vence, el acceso a las funciones de
            conciliación se suspende hasta que renueves.
          </p>
        </section>

        <section>
          <h2 className="font-bold text-navy-900 mb-2">5. Cancelaciones y reembolsos</h2>
          <p>
            Puedes dejar de renovar tu suscripción en cualquier momento sin penalidad; seguirás
            teniendo acceso hasta el final del periodo ya pagado. Los pagos ya realizados por un
            periodo (mensual o anual) no son reembolsables salvo error de cobro imputable a
            Conciliabanco.
          </p>
        </section>

        <section>
          <h2 className="font-bold text-navy-900 mb-2">6. Tus datos y archivos</h2>
          <p>
            Los extractos bancarios y auxiliares contables que subes siguen siendo de tu
            propiedad. Los usamos únicamente para prestarte el servicio (procesar la
            conciliación, generar reportes y mantener tu historial). Ver la{' '}
            <a href="/privacidad" className="text-brand-blue">Política de privacidad</a> para el
            detalle de tratamiento de datos personales.
          </p>
        </section>

        <section>
          <h2 className="font-bold text-navy-900 mb-2">7. Suspensión y terminación</h2>
          <p>
            Podemos suspender el acceso de una cuenta por falta de pago, uso indebido de la
            plataforma, o si detectamos actividad fraudulenta. Puedes solicitar la eliminación de
            tu cuenta y tus datos en cualquier momento escribiendo a{' '}
            <a href="mailto:concilia@conciliabanco.com" className="text-brand-blue">concilia@conciliabanco.com</a>.
          </p>
        </section>

        <section>
          <h2 className="font-bold text-navy-900 mb-2">8. Límite de responsabilidad</h2>
          <p>
            En la máxima medida permitida por la ley, Conciliabanco no será responsable por
            perjuicios indirectos, lucro cesante, o decisiones contables/tributarias tomadas con
            base en los resultados de una conciliación sin la debida revisión humana.
          </p>
        </section>

        <section>
          <h2 className="font-bold text-navy-900 mb-2">9. Ley aplicable</h2>
          <p>
            Estos términos se rigen por las leyes de la República de Colombia. Cualquier
            controversia se someterá a los jueces competentes de Colombia.
          </p>
        </section>
      </div>
    </div>
  );
}
